<template>
  <div id="orderlist" style="width: 100%;height: 100%">
    <el-row class="orderDetailTitleData">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>订单ID</span>：{{ this.$route.params.id }}</li>
          <li><span>订单编号</span>：{{ titleData.ORDER_CODE }}</li>
          <li><span>送货日期</span>：{{ titleData.SEND_DAY }}</li>
          <li><span>总金额</span>：{{ titleData.REAL_TOTAL_GYS_FEE }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>客户</span>：{{ titleData.GYS_NAME }}</li>
          <li><span>供应商</span>：{{ titleData.SUPPLIER_NAME }}</li>
          <li><span>地址</span>：{{ titleData.ADDRESS }}</li>
          <li><span>电话</span>：{{ titleData.TELPHONE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row style="margin-top: 24px">
      <el-table :data="拉取订单详情列表"  border stripe  style="width: 100%">
        <el-table-column type="index" width="50" label="序号"></el-table-column>

        <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="100"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="200"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位" min-width="100"></el-table-column>
        <el-table-column prop="GYS_PRICE" label="采购价" min-width="100"></el-table-column>
        <el-table-column prop="BEFORE_TAX_PRICE" label="不含税采购价" min-width="100"></el-table-column>
        <el-table-column prop="PROJECT_SALE_PRICE" label="销售价" min-width="100"></el-table-column>
<!--        <el-table-column prop="PROJECT_SALE_PRICE_BEFORE_TAX" label="不含税销售价" min-width="100"></el-table-column>-->
        <el-table-column prop="PROJECT_SALE_PRICE_BEFORE_TAX" label="不含税销售价">
          <template slot-scope="scope">
            <span>{{ Number(scope.row.PROJECT_SALE_PRICE_BEFORE_TAX).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="TAX_RATE" label="税率" min-width="100"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="订购数量" min-width="100"></el-table-column>
        <el-table-column prop="NEED_COUNT" label="送货数量" min-width="100"></el-table-column>
        <el-table-column prop="REAL_COUNT" label="实收数量" min-width="100"></el-table-column>
        <el-table-column prop="TOTAL_FEE" label="采购总金额" min-width="100"></el-table-column>
        <el-table-column prop="PRODUCT_FEE_BEFORE_TAX" label="不含税采购总金额" min-width="100"></el-table-column>
        <el-table-column prop="销售总金额" label="销售总金额" min-width="100"></el-table-column>
        <el-table-column prop="不含税销售总金额" label="不含税销售总金额" min-width="100"></el-table-column>
      </el-table>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-show="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="this.statusFlag === 0" style="color:#E6A23C">暂无流程记录信息</h4>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { 拉取订单详情 } from 'api/DSOrder';
import VDSOrderDetailTitleData from '@/components/DSOrder/DSOrderDetailTitleData.vue';

export default {
  components: { VDSOrderDetailTitleData },
  data() {
    return {
      拉取订单详情列表: [],
      titleData: [{
        GYS_NAME: '',
        SUPPLIER_NAME: '',
        ADDRESS: '',
        TELPHONE: '',
        ORDER_CODE: '',
        SEND_DAY: '',
        REAL_TOTAL_GYS_FEE: 0,
      }],
      statusFlag: 0,
      checkData: [],
    };
  },
  created() {
    this.拉取订单详情();
  },
  computed: {

  },
  methods: {
    拉取订单详情() {
      const params = {
        ID: this.$route.params.id,
      };
      拉取订单详情(params).then(res => {
        this.拉取订单详情列表 = res[0].list.map((item) => ({
          ...item,
          PRODUCT_CODE: item.PRODUCT_CODE.toString(),
          TOTAL_FEE: item.TOTAL_FEE.toFixed(2),
          BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2),
          NEW_BEFORE_TAX_PRICE: Number((item.REAL_PRICE / (1 + item.TAX_RATE / 100)).toFixed(10)),
          销售总金额: (Number((item.PROJECT_SALE_PRICE * item.REAL_COUNT).toFixed(3))).toFixed(2),
          不含税销售总金额: Number(item.PROJECT_SALE_PRICE_BEFORE_TAX * item.PRODUCT_COUNT).toFixed(2),
        }));
        this.titleData = res.length > 0 ? res[0].title[0] : [];
        this.checkData = res[0].OR ? res[0].OR[0].DATA : [];
        this.statusFlag = res[0].OR ? res[0].OR[0].RN : 0;
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.拉取订单详情();
    },
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DSOrder/DSOrdeInquiryDetail.vue